module.exports = __webpack_public_path__ + "assets/portal-jabar-logo.21593322.svg";